"use client";

import HelpPage from "@repo/next-shared/components/help-page/help-page";
import HelpPageContactLink from "@repo/next-shared/components/help-page/help-page-contact-link";
import { Separator } from "@repo/ui/components/ui/separator";

export default function HelpSellerPage() {
  return (
    <div className="w-full">
      <HelpPage portal="SELLER" />
      <Separator className="my-10 max-md:my-4 dark: bg-secondary-gray3"></Separator>
      <HelpPageContactLink contactFormLink="help/contact" />
    </div>
  );
}
